// TODO/HINT Atualizar fontes com base no mockup
const light = '"Montserrat", "Helvetica", "Arial", sans-serif';
const bold = '"Montserrat bold", "Helvetica", "Arial", sans-serif';
const medium = '"Montserrat medium", "Helvetica", "Arial", sans-serif';
const roman = '"Montserrat roman", "Helvetica", "Arial", sans-serif';
const regular = '"Montserrat regular", "Helvetica", "Arial", sans-serif';
const italic = '"Montserrat italic", "Helvetica", "Arial", sans-serif';
const semibold = '"Montserrat semibold", "Helvetica", "Arial", sans-serif';
const sizes = {
  extraSmall: "0.625rem", // TODO/HINT 10px
  smaller: "0.75rem", // TODO/HINT 12px
  small: "0.875rem", // TODO/HINT 14px
  regular: "1rem", // TODO/HINT 16px
  medium: "1.125rem", // TODO/HINT 18px
  large: "1.375rem", // TODO/HINT 22px
  extraLarge: "2.625rem", // TODO/HINT 42px
};

const fonts = {
  bold,
  light,
  sizes,
  medium,
  roman,
  italic,
  semibold,
  regular,
};

export default fonts;
